export const IMAGE_HEIGHT_SMALL = 170;
export const IMAGE_HEIGHT_LARGE = 270;
export const IMAGE_WIDTH_SMALL = 265;
export const IMAGE_WIDTH_LARGE = 444;
